import { newThemeEnabled } from '@wm-front/core-tools'

/**
 * Whether the 2026 theme is on (PRENG-8287). A signal read: inside a `computed` (column definitions, for example) the
 * result recomputes when the `webapps-new-theme` flag answers, even after the first render
 * @returns {boolean}
 */
export function isTheme2026(): boolean {
  return newThemeEnabled()
}
